// removed by extract-text-webpack-plugin
module.exports = {"root":"NotFoundPage__root__20iSh","content":"NotFoundPage__content__2hkmf","number":"NotFoundPage__number__2JUHg","heading":"NotFoundPage__heading__1ev_K","description":"NotFoundPage__description__3PWnB","searchForm":"NotFoundPage__searchForm__3HF5y"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFoundPage/NotFoundPage.css
// module id = 2349
// module chunks = 0